import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import { AccountingHttpService } from '@core/services/http';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';
import { Financial } from '@shared/components/financial';
import { AccountingActions } from '@store/actions';
import { AccountingSelectors } from '@store/selectors/accounting.selectors';

export const AccountingFinancial = () => {
  const dispatch = useDispatch();
  const [projectBundleID] = getProjectBundleIDParamFromUrl();

  const isFinancialLoading = useSelector(
    AccountingSelectors.getFinancialTabIsLoading,
  );
  const isFinancialLoaded = useSelector(
    AccountingSelectors.getFinancialTabIsLoaded,
  );

  const fetchData = async () => {
    if (!isFinancialLoaded) {
      dispatch(AccountingActions.setFinancialTabLoading.done(true));

      await HttpService.getHttpRequests(
        AccountingHttpService,
      ).getAccountingFinancial(projectBundleID);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, isFinancialLoaded]);

  if (isFinancialLoading || !isFinancialLoaded) {
    return (
      <div className="prov-accounting-financial loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Financial
      feeAccessPath="accounting"
      siteDataRootPath={['accounting', 'accountingSite']}
      projectTypeSelector={AccountingSelectors.getProjectType}
      projectIdSelector={AccountingSelectors.getProjectId}
    />
  );
};
